import SECRETS from "src/common/secrets";
import { getaudioUri } from "./rest";

export const getAudioUri = async (text: string, targetLang: string) => {
    try {
        const configReqHeader = new Headers();
        configReqHeader.append('userID', process.env.REACT_APP_BHASHINI_USERID || SECRETS.REACT_APP_BHASHINI_USERID);
        configReqHeader.append('ulcaApiKey', process.env.REACT_APP_BHASHINI_ULCA_APIKEY || SECRETS.REACT_APP_BHASHINI_ULCA_APIKEY);
        configReqHeader.append('Content-Type', 'application/json');

        const configReqPayload = {
            pipelineTasks: [
                {
                    taskType: 'asr',
                    config: {
                        language: { sourceLanguage: 'en' }
                    }
                },
                {
                    taskType: 'translation',
                    config: {
                        language: {
                            sourceLanguage: 'en',
                            targetLanguage: targetLang
                        }
                    }
                },
                {
                    taskType: 'tts',
                    config: {
                        language: { sourceLanguage: targetLang }
                    }
                }
            ],
            pipelineRequestConfig: { pipelineId: '64392f96daac500b55c543cd' }
        };

        const configReqOptions: RequestInit = {
            method: 'POST',
            headers: configReqHeader,
            body: JSON.stringify(configReqPayload)
        };

        const configResponse = await fetch('https://meity-auth.ulcacontrib.org/ulca/apis/v0/model/getModelsPipeline', configReqOptions);
        const configResult = await configResponse.json();

        const callbackUrl = configResult.pipelineInferenceAPIEndPoint.callbackUrl;
        const computeCallAuthorizationKey = configResult.pipelineInferenceAPIEndPoint.inferenceApiKey.name;
        const computeCallAuthorizationValue = configResult.pipelineInferenceAPIEndPoint.inferenceApiKey.value;
        let nmtServiceId = '', ttsServiceId = '';

        for (const eachResp of configResult.pipelineResponseConfig) {
            if (eachResp.taskType === 'translation') {
                nmtServiceId = eachResp.config[0].serviceId;
            }
            else if (eachResp.taskType === 'tts') {
                ttsServiceId = eachResp.config[0].serviceId;
            }
        }
        if (!computeCallAuthorizationKey || !computeCallAuthorizationValue || !nmtServiceId || !ttsServiceId || !callbackUrl) {
            throw new Error('Unable to generate voice config!');
        }

        const pipelineHeader = new Headers();
        pipelineHeader.append(`${computeCallAuthorizationKey}`, computeCallAuthorizationValue);
        pipelineHeader.append('Content-Type', 'application/json');

        const pipelinePayload = {
            pipelineTasks: [
                {
                    taskType: 'translation',
                    config: {
                        language: {
                            sourceLanguage: 'en',
                            targetLanguage: targetLang
                        },
                        serviceId: nmtServiceId
                    }
                },
                {
                    taskType: 'tts',
                    config: {
                        language: { sourceLanguage: targetLang },
                        serviceId: ttsServiceId,
                        gender: 'female',
                        samplingRate: 8000
                    }
                }
            ],
            inputData: {
                input: [{ source: text }]
            }
        };

        const pipelineReqOpt: RequestInit = {
            method: 'POST',
            headers: pipelineHeader,
            body: JSON.stringify(pipelinePayload),
        };

        const response = await fetch(callbackUrl, pipelineReqOpt);
        const result = await response.json();
        const audioContent = result.pipelineResponse[1].audio[0].audioContent;
        return getaudioUri(audioContent);
    } catch (error) {
        console.log(error);
        throw new Error('Unable to generate voice!');
    }
};